var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"checkbox\" ng-class='{\"selected\": $bbQuestionCtrl.question.answer}'>\n<label>\n<input name=\"q{{$bbQuestionCtrl.question.id}}\" id=\"{{$bbQuestionCtrl.question.id}}\" ng-model=\"$bbQuestionCtrl.question.answer\" ng-checked='$bbQuestionCtrl.question.answer == \"1\"' ng-change=\"$bbQuestionCtrl.recalc()\" ng-required=\"$bbQuestionCtrl.question.currentlyShown && (($bbQuestionCtrl.adminRequired && $bbQuestionCtrl.question.required) || ($bbQuestionCtrl.question.required && !bb.isAdmin))\" type=\"checkbox\" value=\"1\">\n{{$bbQuestionCtrl.name}}\n</label>\n</div>";
var id1="core/-inputs/question/question_check.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/core/-inputs/question/question_check.html
// module id = 920
// module chunks = 0